module.exports = __webpack_public_path__ + "img/Monte_Kope_13.208e19ea.jpg";